import React from 'react';

import { CloudUploadOutlined, DownOutlined } from '@ant-design/icons';
import { TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';
import { Menu } from 'antd';

import { Button } from 'components/Button';
import { Dropdown } from 'components/Dropdown';

import { useGlobalApp } from 'hooks/useGlobalApp';

import { truthy } from 'utils/boolean';
import { hasUserPermission } from 'utils/roleAndTenant';
import { isMaxShelfLifeEnabled } from 'utils/tenantSettings';

import {
  showExcludeIncludeCSVModal,
  showItemInheritanceCSVModal,
  showLeadTimeCSVModal,
  showMaxShelfLifeCSVModal,
  showMinimumOrderQuantityModal,
  showMinMaxCSVModal,
  showPlannableCSVModal,
  showSafetyStockCSVModal,
  showStockFloorModal,
  showSupplierMinimumsCSVModal,
  showSupplierOrderCycleCSVModal,
  showSupplierReviewCycleCSVModal,
  showSupplierTargetsCSVModal,
} from './utils';

export const BulkImportDropdown = () => {
  const { activeTenant } = useGlobalApp();
  const maxShelfLifeEnabled = isMaxShelfLifeEnabled();

  const enabledColumns = [
    {
      key: 'Exclude',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Exclude/Include',
      onClick: showExcludeIncludeCSVModal,
    },

    {
      key: 'Safety Stock',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Safety Stock',
      onClick: showSafetyStockCSVModal,
    },
    {
      key: 'Lead Time',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Lead Time',
      onClick: showLeadTimeCSVModal,
    },
    {
      key: 'Stock Floor',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Stock Floor',
      onClick: showStockFloorModal,
    },
    {
      key: 'Minimum Order Quantity',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Minimum Order Quantity',
      onClick: showMinimumOrderQuantityModal,
    },
    {
      key: 'Min/Max',
      permission: TenantUserPermission.ActionExportMinMax,
      label: 'Min/Max',
      onClick: showMinMaxCSVModal,
    },
    {
      key: 'Plannable Inventory',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Plannable Inventory',
      onClick: showPlannableCSVModal,
    },
    {
      key: 'Item Inheritance',
      permission: TenantUserPermission.ActionEditForecastUsage,
      label: 'Item Inheritance',
      onClick: showItemInheritanceCSVModal,
    },
    maxShelfLifeEnabled
      ? {
          key: 'Max Shelf Life',
          permission: TenantUserPermission.ActionEditItemSupplierDetails,
          label: 'Max Shelf Life',
          onClick: showMaxShelfLifeCSVModal,
        }
      : null,
    {
      key: 'Supplier Targets',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Supplier Targets',
      onClick: showSupplierTargetsCSVModal,
    },
    {
      key: 'Supplier Minimums',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Supplier Minimums',
      onClick: showSupplierMinimumsCSVModal,
    },
    {
      key: 'Supplier Review Cycle',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Supplier Review Cycle',
      onClick: showSupplierReviewCycleCSVModal,
    },
    {
      key: 'Supplier Order Cycle',
      permission: TenantUserPermission.ActionEditItemSupplierDetails,
      label: 'Supplier Order Cycle',
      onClick: showSupplierOrderCycleCSVModal,
    },
  ].filter(truthy);
  const permittedColumns = enabledColumns.filter(
    (column) => !column.permission || hasUserPermission(activeTenant, column.permission),
  );

  return (
    <Dropdown
      disabled={permittedColumns.length === 0}
      overlay={
        <Menu>
          {permittedColumns.map((column) => (
            <Menu.Item key={column.key} onClick={column.onClick}>
              {column.label}
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button icon={<CloudUploadOutlined />} disabled={permittedColumns.length === 0}>
        CSV Upload <DownOutlined />
      </Button>
    </Dropdown>
  );
};
